var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMore2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 69"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28",
    cx: 26,
    cy: 18,
    r: 2,
    transform: "rotate(90 26 18)",
    fill: "#C1C1C7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    cx: 18,
    cy: 18,
    r: 2,
    transform: "rotate(90 18 18)",
    fill: "#C1C1C7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    cx: 10,
    cy: 18,
    r: 2,
    transform: "rotate(90 10 18)",
    fill: "#C1C1C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore2);
export default __webpack_public_path__ + "static/media/icon-more2.51a69b0c3b6c62892f17c77841e3e01a.svg";
export { ForwardRef as ReactComponent };